// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cc3fcdfb","239":"c8fc950a","455":"79bf0053"}[chunkId] + ".chunk.js";
};